import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { useTranslation } from 'react-i18next';

const QueriesModal = ({ isOpen, onClose }) => {
    const { userId, token } = useAppContext();
    const [queries, setQueries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const fetchQueries = async () => {
            if (!userId) {
                setError('Kullanıcı bilgisi bulunamadı');
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(`https://ai.kesifaraci.com/service/api/queries`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                if (response.data.result) {
                    setQueries(response.data.data);
                } else {
                    setError('Sorgular yüklenemedi');
                }
            } catch (error) {
                console.error('Error fetching queries:', error);
                setError('Sorgular alınırken bir hata oluştu');
            } finally {
                setLoading(false);
            }
        };

        fetchQueries();
    }, []);

    function anaSayfayaDon() {
        navigate("/");
    }

    const handleQueryClick = async (chatId) => {
        try {
            const response = await axios.get(`https://ai.kesifaraci.com/service/api/responses/chat/${chatId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.result) {
                const messages = response.data.data;

                const allMessages = messages.map((message) => ({
                    id: message.id,
                    query: message.question,
                }));

                const allQuery = [];
                messages.forEach((message) => {
                    allQuery.push(message.question);
                });

                const lastId = allMessages[allMessages.length - 1]?.id;

                if (lastId) {
                    const detailsResponse = await axios.get(
                        `https://ai.kesifaraci.com/service/api/messages/${lastId}/details`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    if (detailsResponse.data.result) {
                        const details = detailsResponse.data.data;
                        const parsedFeatures = JSON.parse(details.features);
                        navigate("/results", {
                            state: {
                                chatId,
                                searchQuery: allQuery,
                                messageDetails: {
                                    all_references: details.all_references,
                                    ext_references: details.ext_references,
                                    deeper_question: details.deeper_question,
                                    search_strategy: details.search_strategy,
                                },
                                features: parsedFeatures,
                                response: {
                                    id: lastId,
                                    chatId: chatId,
                                    question: details.question,
                                    text: details.text,
                                    creationDate: details.creationDate,
                                },
                                allMessage: allMessages,
                            },
                        });

                        onClose();
                    } else {
                        setError("Detaylar alınamadı.");
                    }
                }
            }
        } catch (error) {
            console.error("Hata oluştu:", error);
            setError("Sorgu detayları alınırken bir hata oluştu.");
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={anaSayfayaDon} />

            <div className="relative bg-white w-[90vw] max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg p-6 z-10">
                <button onClick={anaSayfayaDon} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <div className="text-center mb-6">
                    <h2 className="text-2xl font-semibold text-[#3c4f58]">{t('Sorgularım')}</h2>
                </div>

                {loading && (
                    <div className="flex justify-center items-center py-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#3c4f58]"></div>
                    </div>
                )}

                {error && (
                    <div className="text-red-500 text-center py-4">
                        {error}
                    </div>
                )}

                {!loading && !error && queries.length === 0 && (
                    <div className="text-gray-500 text-center py-4">
                        Henüz hiç sorgunuz bulunmuyor.
                    </div>
                )}

                {!loading && !error && queries.length > 0 && (
                    <div className="grid gap-4">
                        {queries.map((query) => {
                            const localDate = new Date(query.creationDate);
                            const localTime = new Date(localDate.getTime() + (localDate.getTimezoneOffset() * 60000));  // Türkiye saati için düzeltme

                            return (
                                <div
                                    key={query.id}
                                    onClick={() => handleQueryClick(query.id)}
                                    className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow cursor-pointer border border-gray-200"
                                >
                                    <h3 className="font-medium text-left text-[#3c4f58] mb-2">{query.question}</h3>
                                    <div className="flex justify-between items-center text-sm text-gray-500">
                                        <span>{localTime.toLocaleString('tr-TR')}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default QueriesModal;
